<template>
  <div
    :style="{
      backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee',
      padding: '10px',
      paddingTop: '20px',
      position: 'relative',
      bottom: '20px',
      minHeight: '100vh',
      height: 'auto'
    }"
  >
    <header-o :model="headerData"></header-o>

    <!-- Loading state -->
    <div v-if="loading" class="text-gray-500"></div>

    <!-- Table -->
    <div style="padding-top: 70px">
      <div
        v-for="(item, index) in historyData"
        :key="item.id"
        :style="{
          backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff'
        }"
        v-if="!loading && historyData.length > 0"
        style="padding: 5px; box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; border-radius: 10px; margin-top: 10px; cursor: pointer;"
      >
        <div class="border-b p-2" @click="redirectToRanking(item.id)">
          <div
            style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 4px !important;"
          >
            <h3
              style="margin: 0px !important; font-size: 12px; font-weight: 600 !important;"
            >
              {{ item.title }}
            </h3>
            <div
              v-if="item.is_live"
              style=" padding: 3px 15px; font-size: 12px; color: #ffffff;"
              :style="{ backgroundColor: isDarkTheme ? topBgColor : '#ba0909' }"
            >
              LIVE
            </div>
          </div>
          <div
            style="text-align: start; margin: 0px !important; font-size: 12px; border-bottom: 1px solid #BEBEBE; padding-bottom: 5px; margin-bottom: 5px !important;"
          >
            <p style="margin: 0px !important;">
              {{ formatDate(item.starts_at) }} - {{ formatDate(item.ends_at) }}
            </p>
          </div>
          <table style="width: 100%;">
            <thead class="bg-gray-100">
              <tr>
                <th style="width: 30%; font-size: 11px; text-align: start;">
                  Rank
                </th>
                <th style="width: 30%; font-size: 11px; text-align: start;">
                  Score
                </th>
                <th style="width: 30%; font-size: 11px; text-align: start;">
                  Prize
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  style=" font-size: 11px; text-align: start; font-weight: 800;"
                >
                  {{ item.user_score_data.rank }}
                </td>
                <td
                  style=" font-size: 11px; text-align: start; font-weight: 800;"
                >
                  {{ item.user_score_data.score }}
                </td>
                <td
                  style=" font-size: 11px; text-align: start; color: #669900;"
                >
                  {{ item.user_score_data.prize }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- No data -->
    <div
      v-if="!loading && historyData.length === 0"
      style="padding: 10px 5px 5px 5px;"
    >
      <div
        :style="{
          backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff'
        }"
        class="text-gray-500 custom-bg"
      >
        <img
          width="100%"
          src="@/assets/broke.png"
          style="width: 60px; height: 60px;"
        />
        <p style="font-size: 15px; font-weight: 800">
          You haven't Done any Activity yet!
        </p>
      </div>
    </div>

    <!-- Pagination -->
    <div v-if="totalPages > 1" class="mt-4 flex items-center gap-2">
      <button
        class="px-3 py-1 border rounded"
        :disabled="currentPage === 1"
        @click="fetchHistory(currentPage - 1)"
      >
        Prev
      </button>
      <span>Page {{ currentPage }} of {{ totalPages }}</span>
      <button
        class="px-3 py-1 border rounded"
        :disabled="currentPage === totalPages"
        @click="fetchHistory(currentPage + 1)"
      >
        Next
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import CustomHeader from "@/components/header.vue";
import { globals } from "@/mixins/globals";

export default {
  name: "LeaderboardContextHistory",
  components: {
    "header-o": CustomHeader
  },
  mixins: [globals],
  data() {
    return {
      historyData: [],
      loading: false,
      error: null,
      currentPage: 1,
      totalPages: 1,
      pageSize: 10
    };
  },
  computed: {
    isDarkTheme() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null;
    },
    mainBgColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.mainBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null;
    },
    topBgColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.topBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.topBgColor;
      }
      return null;
    },
    headingTextColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null;
    },
    offersCardBgColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null;
    }
  },
  methods: {
    redirectToRanking(id) {
      this.$router.push({ name: "LeaderboardRankings", params: { id } });
    },
    async fetchHistory(page = 1) {
      this.loading = true;
      this.error = null;
      try {
        const url =
          this.$store.getters.flyyDomain + "/v1/user_bonanza_history_list";
        const headers = this.$store.getters.headers;

        const res = await axios.get(url, {
          mode: "no-cors",
          headers: headers,
          params: { page }
        });

        if (res.data && Array.isArray(res.data.data)) {
          this.historyData = res.data.data;
          this.currentPage = page;
          this.totalPages = res.data.total_pages || 1;
        } else {
          this.historyData = [];
        }
      } catch (err) {
        this.error = "Failed to fetch history";
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);

      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      const monthNames = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC"
      ];
      const month = monthNames[date.getMonth()];

      return `${hours}:${minutes} ${day} ${month}`;
    }
  },
  mounted() {
    this.fetchHistory();
    this.$store.state.headTitle = "Leaderboard History";
  }
};
</script>

<style scoped>
table {
  border-collapse: collapse;
}

/* Very small phones (iPhone SE, older Android) */
@media (max-width: 360px) {
  .custom-bg {
    height: 80vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    /* background-color: #ffffff; */
    border-radius: 10px;
  }
}

/* Normal mobiles (iPhone 12/13/14/15, Samsung A/M series) */
@media (min-width: 361px) and (max-width: 480px) {
  .custom-bg {
    height: 80vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    /* background-color: #ffffff; */
    border-radius: 10px;
  }
}
</style>
